var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchool = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_187_66",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_187_66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05 17.775C5.71666 17.5917 5.45833 17.3458 5.275 17.0375C5.09166 16.7292 5 16.3833 5 16V11.2L2.6 9.87499C2.41666 9.77499 2.28333 9.64999 2.2 9.49999C2.11666 9.34999 2.075 9.18333 2.075 8.99999C2.075 8.81666 2.11666 8.64999 2.2 8.49999C2.28333 8.34999 2.41666 8.22499 2.6 8.12499L11.05 3.52499C11.2 3.44166 11.3542 3.37916 11.5125 3.33749C11.6708 3.29583 11.8333 3.27499 12 3.27499C12.1667 3.27499 12.3292 3.29583 12.4875 3.33749C12.6458 3.37916 12.8 3.44166 12.95 3.52499L22.475 8.72499C22.6417 8.80833 22.7708 8.92916 22.8625 9.08749C22.9542 9.24583 23 9.41666 23 9.59999V16C23 16.2833 22.9042 16.5208 22.7125 16.7125C22.5208 16.9042 22.2833 17 22 17C21.7167 17 21.4792 16.9042 21.2875 16.7125C21.0958 16.5208 21 16.2833 21 16V10.1L19 11.2V16C19 16.3833 18.9083 16.7292 18.725 17.0375C18.5417 17.3458 18.2833 17.5917 17.95 17.775L12.95 20.475C12.8 20.5583 12.6458 20.6208 12.4875 20.6625C12.3292 20.7042 12.1667 20.725 12 20.725C11.8333 20.725 11.6708 20.7042 11.5125 20.6625C11.3542 20.6208 11.2 20.5583 11.05 20.475L6.05 17.775ZM12 12.7L18.85 8.99999L12 5.29999L5.15 8.99999L12 12.7ZM12 18.725L17 16.025V12.25L12.975 14.475C12.825 14.5583 12.6667 14.6208 12.5 14.6625C12.3333 14.7042 12.1667 14.725 12 14.725C11.8333 14.725 11.6667 14.7042 11.5 14.6625C11.3333 14.6208 11.175 14.5583 11.025 14.475L7 12.25V16.025L12 18.725Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchool);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/school.21be0b1fc9cdaf9827b92d8ba20e0715.svg";